<div class="histo" fxLayout="column" fxLayoutGap="5px">
    <!-- <div fxLayout="column" fxFlex="0 0 auto"> -->
    <!--<mat-button-toggle-group #ladderViewModeGroup="mdButtonToggleGroup" (change)="onMetricChange($event)" vertical="true">
            <mat-button-toggle [value]="MetricTypes.SURVIVAL_HORIZON" [checked]="metric == MetricTypes.SURVIVAL_HORIZON">
                <span>{{MetricTypes.SURVIVAL_HORIZON}}</span>
            </mat-button-toggle>
            <mat-button-toggle [value]="MetricTypes.NET_BREACH" [checked]="metric == MetricTypes.NET_BREACH">
                <span>{{MetricTypes.NET_BREACH}}</span>
            </mat-button-toggle>
            <mat-button-toggle [value]="MetricTypes.GROSS_BREACH" [checked]="metric == MetricTypes.GROSS_BREACH">
                <span>{{MetricTypes.GROSS_BREACH}}</span>
            </mat-button-toggle>
            <mat-button-toggle [value]="MetricTypes.LCR" [checked]="metric == MetricTypes.LCR">
                <span>{{MetricTypes.LCR}}</span>
            </mat-button-toggle>
        </mat-button-toggle-group>-->

    <!-- <mat-select class="histo-select" placeholder="Currency" floatPlaceholder="never">
            <mat-option *ngFor="let currency of currencyChoices" [value]="currency">{{ currency | uppercase }}</mat-option>
        </mat-select>
        <mat-select class="histo-select" placeholder="Metric" floatPlaceholder="never">
            <mat-option *ngFor="let metric of metricChoices" [value]="metric">{{ metric }}</mat-option>
        </mat-select>
        <mat-select class="histo-select" placeholder="Time Frame" floatPlaceholder="never">
            <mat-option *ngFor="let timeframe of timeframeChoices" [value]="timeframe">{{ timeframe }}</mat-option>
        </mat-select> -->
    <!-- <span fxFlex="0 0 auto" class="histo-title liquitics-h3">{{historyTitle}}</span>
        <mat-chip-list fxFlex="0 0 auto" class="histo-stats">
            <mat-chip class="histo-chip" selectable="false" color="primary" selected="true">Average: {{average}}</mat-chip>
            <mat-chip class="histo-chip" selectable="false" color="primary" selected="true">Min: {{min}}</mat-chip>
            <mat-chip class="histo-chip" selectable="false" color="primary" selected="true">Max: {{max}}</mat-chip>
            <mat-chip class="histo-chip" selectable="false" color="primary" selected="true">Standard Deviation: {{stddev}}</mat-chip>
        </mat-chip-list>
    </div> -->
    <div *ngIf="metric !== 'Throughput'" fxFlex="0 0 auto" fxLayout="row">
        <div [hidden]="chartLevel <= 0" fxFlex="1 1 10%">
            <button mat-icon-button (click)="previousChart()">
            <mat-icon class="mat-24">keyboard_return</mat-icon>
        </button>
        </div>
        <mat-slider fxFlex="1 1 90%" [fxHide]="chartLevel !== 0" class="lookbackSlider" [invert]="false" [max]="11" [min]="0" [step]="1" thumbLabel
            tickInterval="1" [vertical]="false" [value]="monthsBack" (change)="monthsBackChanged($event)">
        </mat-slider>
        <span [fxHide]="chartLevel !== 0">Months Back</span>
    </div>
    <div *ngIf="metric !== 'Throughput'" fxFlex="0 0 auto" fxLayout="row">

        <div class="chartwrapper histo-chart" fxFlex="0 0 auto" fxFlex.lt-md="0 0 auto">
            <div id="histochartdiv" class="chartdiv"></div>
        </div>
    </div>
    <p-tabView *ngIf="metric === 'Throughput'" #tabview>
        <p-tabPanel header="Ougoing" fxLayout="column">
            <div class="chartwrapper histo-chart" fxFlex="0 0 auto" fxFlex.lt-md="0 0 auto">
                <div id="outHistDiv" class="chartdiv"></div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Incoming" fxLayout="column">
            <div class="chartwrapper histo-chart" fxFlex="0 0 auto" fxFlex.lt-md="0 0 auto">
                <div id="inHistDiv" class="chartdiv"></div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>

